import React from "react";
import IconAppStore from "../images/icon-app-store.png";
import IconGooglePlay from "../images/icon-google-store.png";
type Props = {
  Landingpage?: any;
};

const LandingPageAppStory = (props: Props) => {
  const { Landingpage } = props;

  const IosDownloadLink = Landingpage?.landing_page?.ios_download_link !== null ? Landingpage?.landing_page?.ios_download_link :
    "https://app.adjust.com/1pvuhxfy?engagement_type=fallback_click",
    AndroidDownloadLink = Landingpage?.landing_page?.android_download_link !== null ? Landingpage?.landing_page?.android_download_link :
      "https://app.adjust.com/1pe80cxa?engagement_type=fallback_click";


  return (<div className="landing-page-app-story">
    <h3>
      حمل التطبيق لاستعراض العقارات
    </h3>
    <div className="list">
      <a
        href={IosDownloadLink}
        target="_blank"
        rel="noreferrer"
      >
        <img src={IconAppStore} alt="app store" />
      </a>
      <a
        href={AndroidDownloadLink}
        target="_blank"
        rel="noreferrer"
      >
        <img src={IconGooglePlay} alt="app store" />
      </a>
    </div>
  </div>
  );
};

export default LandingPageAppStory;
